export default {
  /* ================== mutations ============== */
  SET_USER_REGION: 'SET_USER_REGION',
  SET_USER_GRADE: 'SET_USER_GRADE',
  SET_GRADES: 'SET_GRADES',
  SET_USERINFO: 'SET_USERINFO',
  LOGOUT: 'LOGOUT',
  SET_USERISLOGIN: 'SET_USERISLOGIN',
  SET_TOKEN: 'SET_TOKEN',
  SET_USERINFO_MOUNTED: 'SET_USERINFO_MOUNTED',
  SET_USER_INFO: 'SET_USER_INFO',
  SET_COOKIES: 'SET_COOKIES',
  SET_REGION: 'SET_REGION',
  SET_XAREAID: 'SET_XAREAID',
  SET_TOP_ADV: 'SET_TOP_ADV',
  SET_BOTTOM_ADV: 'SET_BOTTOM_ADV',
  SET_CURRENTGRADE: 'SET_CURRENTGRADE',
  SET_PROTOCOL: 'SET_PROTOCOL',
  SET_SHADE_ADV: 'SET_SHADE_ADV',
  SET_ISALREADYDEGREE: 'SET_ISALREADYDEGREE',
  SET_DIFFICULT_DEGREE: 'SET_DIFFICULT_DEGREE',
  SET_SHOWDEGREETIP: 'SET_SHOWDEGREETIP',
  SET_SHOWDIFFCULTRECOMMEND: 'SET_SHOWDIFFCULTRECOMMEND',
  SET_SHOWDIFFICULTDEGREE: 'SET_SHOWDIFFICULTDEGREE',
  SET_SHOWDIFFICULTGUIDE: 'SET_SHOWDIFFICULTGUIDE',
  SET_SHOWGRAIDNGQUESTION: 'SET_SHOWGRAIDNGQUESTION',
  SET_SHOWGRADINGRESULT: 'SET_SHOWGRADINGRESULT',
  SET_SUBJECTS: 'SET_SUBJECTS',
  SET_NAVIGATION: 'SET_NAVIGATION',
  SET_EXP_TAG: 'SET_EXP_TAG',
  SET_TRACEID: 'SET_TRACEID',
  SET_CART_SWITCH: 'SET_CART_SWITCH',
  /* ================== actions ============== */
  GET_SUBJECTS: 'GET_SUBJECTS',
  GET_GRADES: 'GET_GRADES',
  GET_TOKEN: 'GET_TOKEN',
  SET_USER_XAREAID: 'SET_USER_XAREAID',
  GET_USER_INFO: 'GET_USER_INFO',
  GET_REGION: 'GET_REGION',
  GET_TOP_ADV: 'GET_TOP_ADV',
  GET_BOTTOM_ADV: 'GET_BOTTOM_ADV',
  GET_SHADE_ADV: 'GET_SHADE_ADV',
  // 定级接口 开始
  GET_DIFFICULT_GUIDE: 'GET_DIFFICULT_GUIDE',
  GET_DIFFICULT_DEGREE: 'GET_DIFFICULT_DEGREE',
  // 定级接口 结束
  GET_NAVIGATION: 'GET_NAVIGATION',
  // 获取exp_tag
  GET_EXP_TAG: 'GET_EXP_TAG',
  // 获取购物车开关
  GET_CART_SWITCH: 'GET_CART_SWITCH'
}



// WEBPACK FOOTER //
// ./src/store/types.js